import { IconChevronDropDown } from '@montel/montelpro-shared-components-v2';
import { styled } from 'styled-components';

export const RowExpandedIndicatorCell: React.FunctionComponent<{
	isExpanded: boolean;
}> = ({ isExpanded }) => (
	<IconWrapper>
		{isExpanded ? <IconChevronDropDown /> : <IconChevronDropUp />}
	</IconWrapper>
);

const IconWrapper = styled.div`
	padding-right: 12px;
`;

const IconChevronDropUp = styled(IconChevronDropDown)`
	transform: rotate(180deg);
`;
